import { z } from 'zod';

export const loginSchema = z.object({
  phoneNumber: z
    .string()
    .min(10, 'validation.phoneInvalid')
    .regex(/^\d+$/, 'validation.phoneDigits'),
  password: z.string().min(1, 'validation.passwordRequired'),
});

export type LoginFormValues = z.infer<typeof loginSchema>;
